import { gql } from '@apollo/client';

export const SAVED_SEARCH_FILTERS_GROUPS = gql`
  query getSavedSearchFiltersGroups {
    getSavedSearchFiltersGroups {
      ID
      name
      createdAtISO8601
      filters {
        brandNames
        modelNames
        provinces
        coatingColors
        interiorColors
        powerSupplies
        gearTypes
        tractionTypes
        vendorType
        vehicleTypes
        regions
        provinces
        isListingActive
        isPriceTiedToLoan
        isVehicleCoveredByWarranty
        interiorColors
        coatingColors
        priceLabels
        eurotaxCodes
        modelVersions
        vendorNames
        websites
        optionals
        engineDisplacementInCM3 {
          min
          max
        }
        vehicleRegistrationDateISO8601 {
          min
          max
        }
        powerInHP {
          min
          max
        }
        vehicleKM {
          min
          max
        }
        priceInEUR {
          min
          max
        }
        orderBy {
          sortDirection
          field
        }
      }
    }
  }
`;
